
import useTranslation from '../../hooks/useTranslation'
import ComponentRenderer from './ComponentRenderer'

function DefaultContent() {
  const t = useTranslation()
  const { headline, body, ctaLabel, ctaHref } = t.landing.intro.default
  return (
    <ComponentRenderer
      headline={headline}
      text={body}
      ctaLabel={ctaLabel}
      ctaHref={ctaHref}
    />
  )
}

export default DefaultContent
